const autosuggestApiUrl = 'https://partners.api.skyscanner.net/apiservices/v3/autosuggest/flights';
const API_KEY = 'prtl6749387986743898559646983194'; // PUBLIC TEST KEY
const AUTOSUGGEST_RESULTS_LIMIT = 12;
export const MEDIA_PARTNER_ID = 1335988;

const referralApiUrl = 'https://skyscanner.net';
const referralPath = '/g/referrals/v1';
const referralPages = {
  dayView: '/flights/day-view',
  monthView: '/flights/calendar-month-view',
  browseView: '/flights/browse-view',
  cheapFlightsTo: '/flights/cheap-flights-to',
};

export const CABIN_CLASS_ECONOMY = 'economy';
export const CABIN_CLASS_PREMIUMECONOMY = 'premiumeconomy';
export const CABIN_CLASS_BUSINESS = 'business';
export const CABIN_CLASS_FIRST = 'first';

/**
 * Requests location suggestions from a search term.
 * Result is a list of places like:
 * {
 *  "entityId": "27539733",
 *  "iataCode": "PAR",
 *  "parentId": "27539733",
 *  "name": "Paris",
 *  "countryId": "FR",
 *  "countryName": "France",
 *  "cityName": "Paris",
 *  "location": "48.85662237511698,2.3428759930239886",
 *  "hierarchy": "Paris|Île-de-France|France",
 *  "type": "PLACE_TYPE_CITY",
 *  "highlighting": [...]
 * }
 * See full example in README.md
 *
 * @param searchTerm {string}
 * @returns Promise
 */
export const requestSuggestions = async (searchTerm) => {
  const response = await fetch(autosuggestApiUrl, {
    method: 'POST',
    headers: {
      'x-api-key': API_KEY,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: {
        market: 'UK',
        locale: 'en-GB',
        searchTerm,
        includedEntityTypes: ['PLACE_TYPE_CITY', 'PLACE_TYPE_COUNTRY', 'PLACE_TYPE_AIRPORT'],
      },
      limit: AUTOSUGGEST_RESULTS_LIMIT,
      isDestination: true,
    }),
  });

  return response.json();
};

export const getReferralsUrl = (type) => `${referralApiUrl}${referralPath}${referralPages[type]}`;
